module.exports = __webpack_public_path__ + "img/teamsActive.ba4d7b55.svg";